import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import { LegalPage } from '../../Common/HelpCenter';
import { PRIVACY_TITLE, PRIVACY_SECTIONS } from '../../Common/HelpCenter/legalContent';

const CLSDKPrivacyPolicy = () => (
  <LegalPage
    brand="CLS"
    header={<Header showTopBar={false} />}
    footer={<Footer />}
    title={PRIVACY_TITLE}
    sections={PRIVACY_SECTIONS}
  />
);

export default CLSDKPrivacyPolicy;
